import type { Components } from "react-markdown";

export const MESSAGE_TYPE = {
  USER: "user",
  CLINICIAN: "clinician",
  SYSTEM: "system",
  EVENT: "event",
} as const;

export const MESSAGE_TRUNCATE_LENGTH = 154;

export const DEFAULT_COMPOSER_HEIGHT = 144;

export const MESSAGES_MARKDOWN_STYLES: Components = {
  p: (props) => {
    return <p {...props} className="mb-3 last-of-type:mb-0" />;
  },
};
